export default {
  saveUrl: '/api/interview',
  previewUrl: '/interviews/:id/preview',
  adminInterviewsUrl: '/admin/interviews',
  agencyInterviewsUrl: '/dashboard/interviews',

  remove(url) {
    return axios.delete(url);
  },

  get(interviewId) {
    return axios.get('/api/interview', {
      params: {
        id: interviewId,
      }
    })
      .then((response) => response.data);
  },

  post(data) {
    return axios.post('/api/interview', data)
      .then((response) => response.data);
  },

  review(interviewId) {
    return axios.get(`/api/interviews/${interviewId}/review`)
      .then((response) => response.data);
  },

  approve(interview) {
    return axios.put(`/api/interviews/${interview.id}/approve`, interview)
      .then((response) => response.data);
  },

  reject(interview) {
    return axios.put(`/api/interviews/${interview.id}/reject`, interview)
      .then((response) => response.data);
  },

  delete(interviewId) {
    return axios.delete(`/api/interview/${interviewId}`)
      .then((response) => response.data);
  },
};
